module.exports = __webpack_public_path__ + "static/media/themeisle.a71e713f.svg";